

// Local runs call the backend on 3100; REACT_APP_LOCAL_API_PORT points a second portal at another backend.
const localPort = process.env.REACT_APP_LOCAL_API_PORT || '3100';
const httpLocal = `http://localhost:${localPort}`;
const wsLocal = `ws://localhost:${localPort}`;

export const env = () => {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
        return {
            production: false,
            languagesUrl: httpLocal + "/translation/languages",
            translationUrl: httpLocal + "/translation/translations",
            translationKeysUrl: httpLocal + "/translation/translation-keys",
            mockupsUrl: httpLocal + "/mockups",
            generatePreviewUrl: "http://localhost:8000/mockups/generate-preview",
            insertMockupUrl: "http://localhost:8080/upload-mockup",
            brandsUrl: httpLocal + "/brands",
            brandChannelUrl: httpLocal + "/brand-channel",
            artTypeUrl: httpLocal + "/art-type",
            mockupCategoriesUrl: httpLocal + '/mockup-category',
            ordersUrl: httpLocal + '/orders',
            fontsUrl: httpLocal + '/fonts',
            queuesUrl: httpLocal + '/queue',
            loginUrl: httpLocal + '/employee',
            lineItemUrl: httpLocal + '/line-items',
            scanUrl: httpLocal + '/scanner',
            printerUrl: httpLocal + '/printers',
            printNodeUrl: 'https://api.printnode.com/printjobs',
            jdmlUrl: httpLocal + '/jdml',
            materialsUrl: httpLocal + '/materials',
            authenticationUrl: httpLocal + '/authentication',
            pricingUrl: httpLocal + '/pricing',
            billingUrl: httpLocal + '/billing',
            payoutUrl: httpLocal + '/payout',
            socketUrl: wsLocal + '',
            checklistUrl: httpLocal + "/checklist",
            customersUrl: httpLocal + '/customers',
            shippingUrl: httpLocal + '/shipping',
            invoicesUrl: httpLocal + '/invoices',
            giftwrapsUrl: httpLocal + '/giftwraps',
            bulkUploadUrl: httpLocal + '/bulk-upload',
            wasteUrl: httpLocal + '/waste-tracking',
            v2Url: httpLocal + '/api/v2',
            catalogUrl: httpLocal + '/api/v2/catalog',
            internalOrdersUrl: httpLocal + '/api/v2/internal-orders',
            pluginUrl: httpLocal + '/api/v2/plugin',
            carrierServiceUrl: httpLocal + '/shopify-carrier-service',
            pluginSubscriptionRateUrl: httpLocal + '/api/v2/admin/plugin-subscription-rate',
            artistDashboardUrl: httpLocal + '/api/v2/artist-dashboard',
            designerCatalogUrl: httpLocal + '/v1/designer-catalog',
            designerSampleBundlesUrl: httpLocal + '/v1/designer-sample-bundles',
            interiorProjectsUrl: httpLocal + '/v1/interior-projects',
            interiorShareUrl: httpLocal + '/v1/interior-share',
            interiorBrandingUrl: httpLocal + '/v1/interior-branding',
            baseUrl: httpLocal + '',
            appRequestsUrl: httpLocal + '/app-requests',
            formsUrl: httpLocal + '/forms',
            orderFulfillmentStatusesUrl: httpLocal + '/order-fulfillment-statuses',
            errorReportUrl: httpLocal + '/error-report'
        }
    } else if (process.env.REACT_APP_ENVIRONMENT === 'test') {
        return {
            production: false,
            languagesUrl: "https://test.app.wallblush.com/translation/languages",
            translationUrl: "https://test.app.wallblush.com/translation/translations",
            translationKeysUrl: "https://test.app.wallblush.com/translation/translation-keys",
            mockupsUrl: "https://test.app.wallblush.com/mockups",
            generatePreviewUrl: "https://test.mockup-engine.wallmates.com/mockups/generate-preview",
            insertMockupUrl: "https://test.mockup-engine.wallmates.com/upload-mockup",
            brandsUrl: "https://test.app.wallblush.com/brands",
            brandChannelUrl: "https://test.app.wallblush.com/brand-channel",
            artTypeUrl: "https://test.app.wallblush.com/art-type",
            mockupCategoriesUrl: 'https://test.app.wallblush.com/mockup-category',
            ordersUrl: 'https://test.app.wallblush.com/orders',
            fontsUrl: "https://test.app.wallblush.com/fonts",
            queuesUrl: 'https://test.app.wallblush.com/queue',
            loginUrl: 'https://test.app.wallblush.com/employee',
            lineItemUrl: 'https://test.app.wallblush.com/line-items',

            scanUrl: 'https://test.app.wallblush.com/scanner',
            printerUrl: 'https://test.app.wallblush.com/printers',
            printNodeUrl: 'https://api.printnode.com/printjobs',
            jdmlUrl: 'https://test.app.wallblush.com/jdml',
            materialsUrl: 'https://test.app.wallblush.com/materials',
            authenticationUrl: 'https://test.app.wallblush.com/authentication',
            pricingUrl: 'https://test.app.wallblush.com/pricing',
            billingUrl: 'https://test.app.wallblush.com/billing',
            payoutUrl: 'https://test.app.wallblush.com/payout',
            socketUrl: 'wss://test.app.wallblush.com',
            checklistUrl: "https://test.app.wallblush.com/checklist",
            customersUrl: 'https://test.app.wallblush.com/customers',
            shippingUrl: 'https://test.app.wallblush.com/shipping',
            invoicesUrl: 'https://test.app.wallblush.com/invoices',
            giftwrapsUrl: 'https://test.app.wallblush.com/giftwraps',
            bulkUploadUrl: 'https://test.app.wallblush.com/bulk-upload',
            wasteUrl: 'https://test.app.wallblush.com/waste-tracking',
            v2Url: 'https://test.app.wallblush.com/api/v2',
            catalogUrl: 'https://test.app.wallblush.com/api/v2/catalog',
            internalOrdersUrl: 'https://test.app.wallblush.com/api/v2/internal-orders',
            pluginUrl: 'https://test.app.wallblush.com/api/v2/plugin',
            carrierServiceUrl: 'https://test.app.wallblush.com/shopify-carrier-service',
            pluginSubscriptionRateUrl: 'https://test.app.wallblush.com/api/v2/admin/plugin-subscription-rate',
            artistDashboardUrl: 'https://test.app.wallblush.com/api/v2/artist-dashboard',
            designerCatalogUrl: 'https://test.app.wallblush.com/v1/designer-catalog',
            designerSampleBundlesUrl: 'https://test.app.wallblush.com/v1/designer-sample-bundles',
            interiorProjectsUrl: 'https://test.app.wallblush.com/v1/interior-projects',
            interiorShareUrl: 'https://test.app.wallblush.com/v1/interior-share',
            interiorBrandingUrl: 'https://test.app.wallblush.com/v1/interior-branding',
            baseUrl: 'https://test.app.wallblush.com',
            appRequestsUrl: 'https://test.app.wallblush.com/app-requests',
            formsUrl: 'https://test.app.wallblush.com/forms',
            orderFulfillmentStatusesUrl: 'https://test.app.wallblush.com/order-fulfillment-statuses',
            errorReportUrl: 'https://test.app.wallblush.com/error-report'
        }
    } else { // must be production environment
        return {
            production: true,
            languagesUrl: "https://app.wallblush.com/translation/languages",
            translationUrl: "https://app.wallblush.com/translation/translations",
            translationKeysUrl: "https://app.wallblush.com/translation/translation-keys",
            mockupsUrl: "https://app.wallblush.com/mockups",
            generatePreviewUrl: "https://mockup-engine.wallmates.com/mockups/generate-preview",
            insertMockupUrl: "https://mockup-engine.wallmates.com/upload-mockup",
            brandsUrl: "https://app.wallblush.com/brands",
            brandChannelUrl: "https://app.wallblush.com/brand-channel",
            artTypeUrl: "https://app.wallblush.com/art-type",
            mockupCategoriesUrl: 'https://app.wallblush.com/mockup-category',
            ordersUrl: 'https://app.wallblush.com/orders',
            fontsUrl: "https://app.wallblush.com/fonts",
            queuesUrl: 'https://app.wallblush.com/queue',
            loginUrl: 'https://app.wallblush.com/employee',
            lineItemUrl: 'https://app.wallblush.com/line-items',
            scanUrl: 'https://app.wallblush.com/scanner',
            printerUrl: 'https://app.wallblush.com/printers',
            printNodeUrl: 'https://api.printnode.com/printjobs',
            jdmlUrl: 'https://app.wallblush.com/jdml',
            materialsUrl: 'https://app.wallblush.com/materials',
            authenticationUrl: 'https://app.wallblush.com/authentication',
            pricingUrl: 'https://app.wallblush.com/pricing',
            billingUrl: 'https://app.wallblush.com/billing',
            payoutUrl: 'https://app.wallblush.com/payout',
            socketUrl: 'wss://app.wallblush.com',
            checklistUrl: "https://app.wallblush.com/checklist",
            customersUrl: 'https://app.wallblush.com/customers',
            shippingUrl: 'https://app.wallblush.com/shipping',
            invoicesUrl: 'https://app.wallblush.com/invoices',
            giftwrapsUrl: 'https://app.wallblush.com/giftwraps',
            bulkUploadUrl: 'https://app.wallblush.com/bulk-upload',
            wasteUrl: 'https://app.wallblush.com/waste-tracking',
            v2Url: 'https://app.wallblush.com/api/v2',
            catalogUrl: 'https://app.wallblush.com/api/v2/catalog',
            internalOrdersUrl: 'https://app.wallblush.com/api/v2/internal-orders',
            pluginUrl: 'https://app.wallblush.com/api/v2/plugin',
            carrierServiceUrl: 'https://app.wallblush.com/shopify-carrier-service',
            pluginSubscriptionRateUrl: 'https://app.wallblush.com/api/v2/admin/plugin-subscription-rate',
            artistDashboardUrl: 'https://app.wallblush.com/api/v2/artist-dashboard',
            designerCatalogUrl: 'https://app.wallblush.com/v1/designer-catalog',
            designerSampleBundlesUrl: 'https://app.wallblush.com/v1/designer-sample-bundles',
            interiorProjectsUrl: 'https://app.wallblush.com/v1/interior-projects',
            interiorShareUrl: 'https://app.wallblush.com/v1/interior-share',
            interiorBrandingUrl: 'https://app.wallblush.com/v1/interior-branding',
            baseUrl: 'https://app.wallblush.com',
            appRequestsUrl: 'https://app.wallblush.com/app-requests',
            formsUrl: 'https://app.wallblush.com/forms',
            orderFulfillmentStatusesUrl: 'https://app.wallblush.com/order-fulfillment-statuses',
            errorReportUrl: 'https://app.wallblush.com/error-report'
        }
    }
}

export const environment = env();